export const API_NAPCOBRANZAS = process.env.REACT_APP_API_COBRANZAS ?? "http://192.168.1.200:7000/api";
export const API_NAPFOOD = process.env.REACT_APP_API_NAPFOOD;
export const API_NAPCONTABLE = process.env.REACT_APP_API_NAPCONTABLE;
export const API_NAPCOLEGIOS = process.env.REACT_APP_API_NAPCOLEGIOS;
export const API_NAPNEGOCIOS = process.env.REACT_APP_API_NAPNEGOCIOS;
